<template>
  <div class="tai-xiu-specific-number">
    <Row class="tai-xiu-specific-number-dice-section" type="flex" justify="center">
      <Col class="tai-xiu-specific-number-dice-container">
        <Row class="tai-xiu-specific-number-dice-inner-container" type="flex" :gutter="6">
          <Col class="tai-xiu-specific-number-dice-col" :span="4">
            <new-bet-lot
              type="o11"
              :types="['o11', 'o12', 'o13']"
              :odd="odd('o11')"
              :group="1"
              :game="game"
              :game-data="gameData"
              gameType="tai_xiu"
              :minutes-string="minutesString"
              :seconds-string="secondsString"
              :disallow-betting="disallowBetting"
              :stake-record-sum="stakeRecordSum('o11')"
              @update-session-storage="onUpdateSessionStorage"
            >
              <div
                class="tai-xiu-specific-number-dice"
                :class="{ 'tai-xiu-1-active': diceOneActive }"
                ref="tai-xiu-1-active"
              >
                <img
                  :src="
                    require(`../../../assets/images/tai-xiu/assets/dice-1${
                      diceOneActive ? '-active' : ''
                    }.png`)
                  "
                  alt
                />
                <div v-if="diceOneCounter > 1" class="tai-xiu-total-number">x{{ diceOneCounter }}</div>
                <Row v-if="stakeRecordSum('o11')" type="flex" justify="center">
                  <span
                    class="tai-xiu-specific-number-dice-sum-stake"
                  >{{ stakeRecord(stakeRecordSum("o11")) }}</span>
                </Row>
              </div>
            </new-bet-lot>
          </Col>
          <Col class="tai-xiu-specific-number-dice-col" :span="4">
            <new-bet-lot
              type="o21"
              :types="['o21', 'o22', 'o23']"
              :odd="odd('o21')"
              :group="2"
              :game="game"
              gameType="tai_xiu"
              :game-data="gameData"
              :minutes-string="minutesString"
              :seconds-string="secondsString"
              :disallow-betting="disallowBetting"
              :stake-record-sum="stakeRecordSum('o21')"
              @update-session-storage="onUpdateSessionStorage"
            >
              <div
                class="tai-xiu-specific-number-dice"
                :class="{ 'tai-xiu-2-active': diceTwoActive }"
                ref="tai-xiu-2-active"
              >
                <img
                  :src="
                    require(`../../../assets/images/tai-xiu/assets/dice-2${
                      diceTwoActive ? '-active' : ''
                    }.png`)
                  "
                  alt
                />
                <div v-if="diceTwoCounter > 1" class="tai-xiu-total-number">x{{ diceTwoCounter }}</div>
                <Row v-if="stakeRecordSum('o21')" type="flex" justify="center">
                  <span
                    class="tai-xiu-specific-number-dice-sum-stake"
                  >{{ stakeRecord(stakeRecordSum("o21")) }}</span>
                </Row>
              </div>
            </new-bet-lot>
          </Col>
          <Col class="tai-xiu-specific-number-dice-col" :span="4">
            <new-bet-lot
              type="o31"
              :types="['o31', 'o32', 'o33']"
              :odd="odd('o31')"
              :group="3"
              :game="game"
              :game-data="gameData"
              gameType="tai_xiu"
              :minutes-string="minutesString"
              :seconds-string="secondsString"
              :disallow-betting="disallowBetting"
              :stake-record-sum="stakeRecordSum('o31')"
              @update-session-storage="onUpdateSessionStorage"
            >
              <div
                class="tai-xiu-specific-number-dice"
                :class="{ 'tai-xiu-3-active': diceThreeActive }"
                ref="tai-xiu-3-active"
              >
                <img
                  :src="
                    require(`../../../assets/images/tai-xiu/assets/dice-3${
                      diceThreeActive ? '-active' : ''
                    }.png`)
                  "
                  alt
                />
                <div
                  v-if="diceThreeCounter > 1"
                  class="tai-xiu-total-number"
                >x{{ diceThreeCounter }}</div>
                <Row v-if="stakeRecordSum('o31')" type="flex" justify="center">
                  <span
                    class="tai-xiu-specific-number-dice-sum-stake"
                  >{{ stakeRecord(stakeRecordSum("o31")) }}</span>
                </Row>
              </div>
            </new-bet-lot>
          </Col>
          <Col class="tai-xiu-specific-number-dice-col" :span="4">
            <new-bet-lot
              type="o41"
              :types="['o41', 'o42', 'o43']"
              :odd="odd('o41')"
              :group="4"
              :game="game"
              :game-data="gameData"
              gameType="tai_xiu"
              :minutes-string="minutesString"
              :seconds-string="secondsString"
              :disallow-betting="disallowBetting"
              :stake-record-sum="stakeRecordSum('o41')"
              @update-session-storage="onUpdateSessionStorage"
            >
              <div
                class="tai-xiu-specific-number-dice"
                :class="{ 'tai-xiu-4-active': diceFourActive }"
                ref="tai-xiu-4-active"
              >
                <img
                  :src="
                    require(`../../../assets/images/tai-xiu/assets/dice-4${
                      diceFourActive ? '-active' : ''
                    }.png`)
                  "
                  alt
                />
                <div v-if="diceFourCounter > 1" class="tai-xiu-total-number">x{{ diceFourCounter }}</div>
                <Row v-if="stakeRecordSum('o41')" type="flex" justify="center">
                  <span
                    class="tai-xiu-specific-number-dice-sum-stake"
                  >{{ stakeRecord(stakeRecordSum("o41")) }}</span>
                </Row>
              </div>
            </new-bet-lot>
          </Col>
          <Col class="tai-xiu-specific-number-dice-col" :span="4">
            <new-bet-lot
              type="o51"
              :types="['o51', 'o52', 'o53']"
              :odd="odd('o51')"
              :group="5"
              :game="game"
              :game-data="gameData"
              gameType="tai_xiu"
              :minutes-string="minutesString"
              :seconds-string="secondsString"
              :disallow-betting="disallowBetting"
              :stake-record-sum="stakeRecordSum('o51')"
              @update-session-storage="onUpdateSessionStorage"
            >
              <div
                class="tai-xiu-specific-number-dice"
                :class="{ 'tai-xiu-5-active': diceFiveActive }"
                ref="tai-xiu-5-active"
              >
                <img
                  :src="
                    require(`../../../assets/images/tai-xiu/assets/dice-5${
                      diceFiveActive ? '-active' : ''
                    }.png`)
                  "
                  alt
                />
                <div v-if="diceFiveCounter > 1" class="tai-xiu-total-number">x{{ diceFiveCounter }}</div>
                <Row v-if="stakeRecordSum('o51')" type="flex" justify="center">
                  <span
                    class="tai-xiu-specific-number-dice-sum-stake"
                  >{{ stakeRecord(stakeRecordSum("o51")) }}</span>
                </Row>
              </div>
            </new-bet-lot>
          </Col>
          <Col class="tai-xiu-specific-number-dice-col" :span="4">
            <new-bet-lot
              type="o61"
              :types="['o61', 'o62', 'o63']"
              :odd="odd('o61')"
              :group="6"
              :game="game"
              :game-data="gameData"
              gameType="tai_xiu"
              :minutes-string="minutesString"
              :seconds-string="secondsString"
              :disallow-betting="disallowBetting"
              :stake-record-sum="stakeRecordSum('o61')"
              @update-session-storage="onUpdateSessionStorage"
            >
              <div
                class="tai-xiu-specific-number-dice"
                :class="{ 'tai-xiu-6-active': diceSixActive }"
                ref="tai-xiu-6-active"
              >
                <img
                  :src="
                    require(`../../../assets/images/tai-xiu/assets/dice-6${
                      diceSixActive ? '-active' : ''
                    }.png`)
                  "
                  alt
                />
                <div v-if="diceSixCounter > 1" class="tai-xiu-total-number">x{{ diceSixCounter }}</div>
                <Row v-if="stakeRecordSum('o61')" type="flex" justify="center">
                  <span
                    class="tai-xiu-specific-number-dice-sum-stake"
                  >{{ stakeRecord(stakeRecordSum("o61")) }}</span>
                </Row>
              </div>
            </new-bet-lot>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row class="tai-xiu-specific-number-plate-section" type="flex" justify="center">
      <img
        style="height:intrinsic"
        src="../../../assets/images/tai-xiu/assets/dice-plate-1.png"
        width="100%"
      />
    </Row>
    <Row
      class="tai-xiu-specific-number-multiplier-section"
      type="flex"
      justify="center"
      align="bottom"
    >
      <Col class="tai-xiu-specific-number-multiplier-container">
        <Row class="tai-xiu-specific-number-multiplier-inner-container" type="flex" :gutter="12">
          <Col :span="8">
            <Row
              class="tai-xiu-specific-number-multiplier"
              type="flex"
              justify="center"
            >{{ $t("tai_xiu.1_dice") }} @ {{ odd("o11") }}</Row>
          </Col>
          <Col :span="8">
            <Row
              class="tai-xiu-specific-number-multiplier"
              type="flex"
              justify="center"
            >{{ $t("tai_xiu.2_dice") }} @ {{ odd("o12") }}</Row>
          </Col>
          <Col :span="8">
            <Row
              class="tai-xiu-specific-number-multiplier"
              type="flex"
              justify="center"
            >{{ $t("tai_xiu.3_dice") }} @ {{ odd("o13") }}</Row>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";
import { indexOf, isEqual } from "lodash";
import { TimelineLite } from "gsap";

export default {
  mixins: [betLotMixin],
  props: ["game", "winNumbers", "gameData"],
  data() {
    return {
      diceOneCounter: 0,
      diceTwoCounter: 0,
      diceThreeCounter: 0,
      diceFourCounter: 0,
      diceFiveCounter: 0,
      diceSixCounter: 0
    };
  },
  components: {
    Row,
    Col,
    NewBetLot
  },
  computed: {
    diceOneActive() {
      // this.calculateDice();
      return indexOf(this.winNumbers, 1) >= 0;
    },
    diceTwoActive() {
      return indexOf(this.winNumbers, 2) >= 0;
    },
    diceThreeActive() {
      return indexOf(this.winNumbers, 3) >= 0;
    },
    diceFourActive() {
      return indexOf(this.winNumbers, 4) >= 0;
    },
    diceFiveActive() {
      return indexOf(this.winNumbers, 5) >= 0;
    },
    diceSixActive() {
      return indexOf(this.winNumbers, 6) >= 0;
    }
  },
  watch: {
    winNumbers(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.resetDiceCounter();
        this.calculateDice();
        if (this.diceOneActive) {
          this.animateDice(1);
        }

        if (this.diceTwoActive) {
          this.animateDice(2);
        }

        if (this.diceThreeActive) {
          this.animateDice(3);
        }

        if (this.diceFourActive) {
          this.animateDice(4);
        }

        if (this.diceFiveActive) {
          this.animateDice(5);
        }

        if (this.diceSixActive) {
          this.animateDice(6);
        }
      }
    }
  },
  methods: {
    stakeRecord(v) {
      return display_numeric(v);
    },
    resetDiceCounter() {
      this.diceOneCounter = 0;
      this.diceTwoCounter = 0;
      this.diceThreeCounter = 0;
      this.diceFourCounter = 0;
      this.diceFiveCounter = 0;
      this.diceSixCounter = 0;
    },
    calculateDice() {
      for (var i = 0; i < this.winNumbers.length; i++) {
        switch (this.winNumbers[i]) {
          case 1:
            this.diceOneCounter++;
            break;
          case 2:
            this.diceTwoCounter++;
            break;
          case 3:
            this.diceThreeCounter++;
            break;
          case 4:
            this.diceFourCounter++;
            break;
          case 5:
            this.diceFiveCounter++;
            break;
          case 6:
            this.diceSixCounter++;
            break;
        }
      }
    },
    animateDice(diceNo) {
      let vm = this;
      // this.$nextTick(() => {
      //   let shakeAni = new TimelineLite({ paused: true });
      //   shakeAni
      //     .from(vm.$refs[`tai-xiu-${diceNo}-active`], 1, {
      //       x: 2,
      //       y: 2,
      //       ease: RoughEase.ease.config({
      //         strength: 8,
      //         points: 50,
      //         taper: "none",
      //         randomize: true,
      //         clamp: false
      //       })
      //     })
      //     .set(vm.$refs[`tai-xiu-${diceNo}-active`], { x: 0, y: 0 });

      //   shakeAni.restart();
      // });
    }
  },
  beforeMount() {
    this.calculateDice();
  }
};
</script>

<style lang="scss" scoped>
.tai-xiu-total-number {
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  padding: 2.5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-radius: 3px;
}

.tai-xiu-specific-number {
  padding-top: 10px;
  background: linear-gradient(
    90deg,
    $tai-xiu-background-light-gradient-color-1 0%,
    $tai-xiu-background-light-gradient-color-2 50%,
    $tai-xiu-background-light-gradient-color-1 100%
  );
  height: 120px;
  position: relative;
}

.tai-xiu-specific-number-dice-section,
.tai-xiu-specific-number-plate-section {
  max-width: 360px;
  margin: 0 auto;
  height: 72px;
}

.tai-xiu-specific-number-dice-container {
  width: 75%;
  position: unset;
}

.tai-xiu-specific-number-dice img {
  width: 100%;
  cursor: pointer;
}

.tai-xiu-specific-number-dice-inner-container.ivu-row-flex
  > .ivu-col:nth-of-type(2),
.tai-xiu-specific-number-dice-inner-container.ivu-row-flex
  > .ivu-col:nth-last-of-type(2) {
  margin-top: 6px;
}

.tai-xiu-specific-number-dice-inner-container.ivu-row-flex
  > .ivu-col:nth-of-type(3),
.tai-xiu-specific-number-dice-inner-container.ivu-row-flex
  > .ivu-col:nth-last-of-type(3) {
  margin-top: 12px;
}

.tai-xiu-specific-number-plate-section {
  margin-top: -50px;
}

.tai-xiu-specific-number-multiplier-section {
  height: 28px;
  overflow: hidden;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  width: 100%;
}

.tai-xiu-specific-number-multiplier-container {
  width: 97%;
  height: 28px;
}

.tai-xiu-specific-number-dice-inner-container {
  margin-bottom: 14px;
  z-index: 1;
}

.tai-xiu-specific-number-multiplier {
  padding: 5px 0;
  width: 100%;
  background-color: rgba(white, 0.6);
  border-radius: 6px;
  color: $tai-xiu-theme-color-3;
  font-size: 11px;
  font-weight: bold;
}

.tai-xiu-specific-number-multiplier-inner-container.ivu-row-flex
  > .ivu-col:nth-of-type(2) {
  margin-bottom: 32px;
}

@keyframes glowing {
  0% {
    box-shadow: 0 0 -10px $tai-xiu-theme-color-1;
  }
  40% {
    box-shadow: 0 0 10px $tai-xiu-theme-color-1;
  }
  60% {
    box-shadow: 0 0 10px $tai-xiu-theme-color-1;
  }
  100% {
    box-shadow: 0 0 -10px $tai-xiu-theme-color-1;
  }
}

.tai-xiu-1-active img,
.tai-xiu-2-active img,
.tai-xiu-3-active img,
.tai-xiu-4-active img,
.tai-xiu-5-active img,
.tai-xiu-6-active img {
  border-radius: 7px;
  box-shadow: 0 0 10px $tai-xiu-theme-color-1;
  // animation: glowing 0.3s 1;
  // box-shadow: 0 0 -10px $tai-xiu-theme-color-1;
}

.tai-xiu-specific-number-dice img:hover {
  @extend .tai-xiu-game-btn-img-hover;
  border-radius: 5px;
}

.tai-xiu-specific-number-dice-sum-stake {
  margin-top: -5px;
  border-radius: 5px;
  padding: 1px 4px;
  font-size: 8px;
  font-weight: bold;
  background-color: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
}

// @media only screen and (max-width: 480px) {
//   .tai-xiu-specific-number-plate-section {
//     margin-top: -56px;
//   }
// }

// @media only screen and (max-width: 420px) {
//   .tai-xiu-specific-number-plate-section {
//     margin-top: -52px;
//   }
// }

// @media only screen and (max-width: 360px) {
//   .tai-xiu-specific-number-multiplier-container {
//     width: 96%;
//   }

//   .tai-xiu-specific-number-plate-section {
//     margin-top: -48px;
//   }

//   .tai-xiu-specific-number-multiplier-section {
//     height: 54px;
//     margin-top: -52px;
//   }

//   .tai-xiu-specific-number-multiplier-inner-container.ivu-row-flex
//     > .ivu-col:nth-of-type(2) {
//     margin-bottom: 18px;
//   }

//   .tai-xiu-specific-number-multiplier-inner-container {
//     margin-top: unset;
//   }
// }

.locale_5 .tai-xiu-specific-number-multiplier {
  font-size: 10px;
}

.tai-xiu-specific-number-dice-col{
  position: unset;
}

.tai-xiu-specific-number-dice{
  position: relative;
}


</style>
